import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';

import ListInternalUser from './submodules/list';
import AddInternalUser from './submodules/add';
import EditInternalUser from './submodules/edit';

const InternalUserDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.dashboard}
				configResourceName={DASHBOARD_RESOURCES.internalUser}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.internalUser].getInternalUserList}
				path={`${path}/list`}
				component={ListInternalUser}
				exact
			/>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.dashboard}
				configResourceName={DASHBOARD_RESOURCES.internalUser}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.internalUser].addInternalUser}
				path={`${path}/add`}
				component={AddInternalUser}
				exact
			/>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.dashboard}
				configResourceName={DASHBOARD_RESOURCES.internalUser}
				configActionName={DASHBOARD_SCOPES[DASHBOARD_RESOURCES.internalUser].editInternalUser}
				path={`${path}/edit`}
				component={EditInternalUser}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default InternalUserDashboard;
